export default "/_next/static/chunks/fonts/Source Sans Pro Extra LightIt-54cd08b0003a598004f3adb4600557f7.otf";